<template>
    <tr>
        <td>
            <select v-model="jogviszony.intezmenyKod" class="form-control" title="A pályamunka készítésekor látogatott intézmény kódja" required @change="jogviszony.karKod = ''">
                <option value=""></option>
                <option v-for="(intezmeny) in this.intezmenyek" :value="intezmeny.kod">{{ intezmeny.nev }}</option>
            </select>
        </td>
        <td>
            <select v-model="jogviszony.karKod" class="form-control" title="A pályamunka készítésekor látogatott kar kódja">
                <option v-for="(kar) in this.availableKar()" :value="kar.kod">{{ kar.nev }}</option>
            </select>
        </td>
        <td>
            <input type="number" id='aktivFelevekSzama' v-model="jogviszony.aktivFelevekSzama" min="1" max="50" class="form-control" title="Aktív félévek száma" required />
        </td>
        <td>
            <select v-model="jogviszony.kepzesTipusa" class="form-control" title="Képzés típusa" required>
                <option value=""></option>
                <option value="O">O</option>
                <option value="BA">BA</option>
                <option value="BSc">BSc</option>
                <option value="MA">MA</option>
                <option value="MSc">MSc</option>
                <option value="FSZ">FSZ</option>
                <option value="BProf">BProf</option>
                <option value="Egyeb">Egyéb</option>
            </select>
        </td>
        <td>
            <select v-model="jogviszony.kepzesMunkarendje" class="form-control" title="Képzés munkarendje" required>
                <option value=""></option>
                <option value="N">nappali</option>
                <option value="E">esti</option>
                <option value="L">levelező</option>
                <option value="T">távoktatás</option>
            </select>
        </td>
        <td>
            <input type="number" id='megkezdesEve' v-model="jogviszony.megkezdesEve" min="2000" max="2050" size="4" class="form-control" title="Képzés megkezdésének éve" required/>
        </td>
        <td>
            <button class="row-icon-delete" @click.prevent="deleteJogviszony" title="Jogviszony törlése"></button>
        </td>
    </tr>
</template>

<script>
export default {
    data() {
        return {
            intezmenyek: []
        }
    },
    async created() {
        this.intezmenyek = await this.$storage.getIntezmenyekJogviszony();
    },
    props: ['jogviszony', 'index', 'hallgato'],
    methods: {
        deleteJogviszony() {
            const index = this.hallgato.felsooktatasiJogviszonyok.indexOf(this.jogviszony);
            if (index > -1)
                this.hallgato.felsooktatasiJogviszonyok.splice(index, 1);
        },
        availableKar() {
            var intezmenyKod = this.jogviszony.intezmenyKod;
            var intezmenyObj = this.intezmenyek.find((x) => x.kod == intezmenyKod);
            if (intezmenyObj)
                return intezmenyObj.karok;
            else
                return [];
        }
    }
}
</script>
